export const getLineitemFieldToNameDict = (lineItemIndex: number) => {
  const currentLineItem = `/campaign/lineitems/${lineItemIndex}`;

  return {
    [`/state/lineitems/${lineItemIndex}/runState`]: "Run State",
    [`/state/lineitems/${lineItemIndex}/running`]: "Running",
    [`/state/lineitems/${lineItemIndex}/archived`]: "Archived State",
    [`${currentLineItem}/adEnvironment`]: "Ad Environment",
    [`${currentLineItem}/name`]: "Name",
    [`${currentLineItem}/description`]: "Description",
    [`${currentLineItem}/start`]: "Start date",
    [`${currentLineItem}/finish`]: "Finish date",
    [`${currentLineItem}/budget/$numberLong`]: "Budget",
    [`${currentLineItem}/budget`]: "Budget",
    [`${currentLineItem}/pacing`]: "Pacing",
    [`${currentLineItem}/cap/type`]: "Cap Type",
    [`${currentLineItem}/cap/value`]: "Cap Value",
    [`${currentLineItem}/cap/value/$numberLong`]: "Cap Value",
    [`${currentLineItem}/impressionLimits/type`]: "Impression Cap Type",
    [`${currentLineItem}/impressionLimits/value/$numberLong`]:
      "Publisher Impression Cap",
    [`${currentLineItem}/impressionLimits/value`]: "Publisher Impression Cap",
    [`${currentLineItem}/ext/installCap/$numberLong`]: "Daily install cap",
    [`${currentLineItem}/ext/installCap`]: "Daily install cap",
    [`${currentLineItem}/frequencyCap`]: "Frequency cap",
    [`${currentLineItem}/xgboost/cpmMax/$numberLong`]:
      "Bidding Autopilot (Maximum CPM)",
    [`${currentLineItem}/xgboost/expectedImpressions/$numberLong`]:
      "Bidding Autopilot (Expected Impressions)",
    [`${currentLineItem}/xgboost/expectedImpressions`]:
      "Bidding Autopilot (Expected Impressions)",
    [`${currentLineItem}/xgboost/roasPercent`]:
      "Bidding Autopilot (ROAS Percent)",
    [`${currentLineItem}/xgboost/userValue`]: "Bidding Autopilot (User Value)",
    [`${currentLineItem}/xgboost/userValue/$numberLong`]:
      "Bidding Autopilot (User Value)",
    [`${currentLineItem}/predictDryRun`]: "Predict dry run",
    [`${currentLineItem}/predictType`]: "Predict Model",
    [`${currentLineItem}/dl4j/cpmMax/$numberLong`]: "Maximum CPM",
    [`${currentLineItem}/dl4j/expectedImpressions/$numberLong`]:
      "Expected Impressions",
    [`${currentLineItem}/bid/$numberLong`]: "Bid Price",
    [`${currentLineItem}/bid`]: "Bid Price",
    [`${currentLineItem}/bidModifierTerms/connectionType`]:
      "Bid Modifier: Connection Type",
    [`${currentLineItem}/landingIds`]: "Landing",
    [`${currentLineItem}/creativeIds`]: "Creatives",
    [`${currentLineItem}/nativeBrowser`]: "Use Native Browser",
    [`${currentLineItem}/trackingAllowed`]: "Device ID Rules: Tracking Allowed",
    [`${currentLineItem}/ifaRequired`]: "Device ID Rules: IFA Required",
    [`${currentLineItem}/exchanges`]: "Exchanges",
    [`${currentLineItem}/sspDealIds`]: "Private Markets",
    [`${currentLineItem}/language`]: "Geo (Language)",
    [`${currentLineItem}/os`]: "OS",
    [`${currentLineItem}/osVersion`]: "Device OS Version",
    [`${currentLineItem}/deviceModel`]: "Device Model",
    [`${currentLineItem}/deviceType`]: "Device Type",
    [`${currentLineItem}/connectionType`]: "Connection Type",
    [`${currentLineItem}/carriers/type`]: "Carrier Type",
    [`${currentLineItem}/carriers/values`]: "Carrier Values",
    [`${currentLineItem}/isRewarded`]: "Video Targeting (Rewarded)",
    [`${currentLineItem}/interstitial`]: "Video Targeting (Interstitial)",
    [`${currentLineItem}/mediumRectangle`]:
      "Video Targeting (Medium rectangle)",
    [`${currentLineItem}/bundlesV2/blacklist`]: "App Bundles Bundles Blacklist",
    [`${currentLineItem}/bundlesV2/whitelist`]: "App Bundles Bundles Whitelist",
    [`${currentLineItem}/ext/publisherIdCPM`]:
      "Override Bid Price (App Bundle)",
    [`${currentLineItem}/placements/blacklist`]: "Tag IDs Bundles Blacklist",
    [`${currentLineItem}/placements/whitelist`]: "Tag IDs Bundles Whitelist",
    [`${currentLineItem}/ext/tagIdCPM`]: "Override Bid Price (Tag Id)",
    [`${currentLineItem}/domainsV2/blacklist`]: "Mobile Web Domains (Exclude)",
    [`${currentLineItem}/domainsV2/whitelist`]: "Mobile Web Domains (Include)",
    [`${currentLineItem}/audienceBundlesV2/type`]: "Audiences",
    [`${currentLineItem}/onlySKAd`]: "Target SKAdNetwork traffic only",
    [`${currentLineItem}/skAdNetworkConfiguration/templateId`]:
      "SKAdNetwork template",
    [`${currentLineItem}/skAdNetworkConfiguration/enabled`]: "Enabled",
    [`${currentLineItem}/ext/skadVersion/whitelist`]:
      "Target SKAdNetwork version",
    [`${currentLineItem}/aakConfiguration/enabled`]: "AdAttributionKit enabled",
    [`${currentLineItem}/ext/sessionDurationExt/max/$numberLong`]:
      "Target session duration (max)",
    [`${currentLineItem}/ext/sessionDurationExt/min/$numberLong`]:
      "Target session duration (min)",
    [`${currentLineItem}/ext/abGroupNumber`]: "AB Group",
    [`${currentLineItem}/xgboost/params/targetCPI`]: "Target CPI",
    [`${currentLineItem}/xgboost/params/targetCPA`]: "Target CPA",
    [`${currentLineItem}/xgboost/params/samplingRate`]: "Sample unknown data",
    [`${currentLineItem}/xgboost/bidPrice`]: '"100% probability" bid price',
    [`${currentLineItem}/xgboost/cpmMax`]: "Bid price limit",
    [`${currentLineItem}/deviceModel`]: "Device Model",
    [`${currentLineItem}/placements`]: "Tag IDs",
    [`${currentLineItem}/revenuePerInstall`]: "Revenue Per Install",
    [`${currentLineItem}/trackingAllowed`]: "Tracking Allowed",
    [`${currentLineItem}/networkAnonymity/anonymityLevelsAllowed`]:
      "Network anonymity",
    [`${currentLineItem}/networkAnonymity/maxAllowableAnonymity`]:
      "Network anonymity (legacy threshold)",
    [`${currentLineItem}/addOmsdk`]: "Enable Adelaide tag",
    [`${currentLineItem}/optimizationType`]: "Optimization type",
    [`${currentLineItem}/directTrafficOnly`]: "Supply path: direct only",
    [`${currentLineItem}/creativeLandingMapping`]:
      "Creative to landing mapping",
    [`${currentLineItem}/bluetooth`]: "Device with bluetooth on",
    [`${currentLineItem}/headset`]: "Device with wired headset",
    [`${currentLineItem}/livestream`]: "Livestream",
    [`${currentLineItem}/rollPositions`]: "Ad Break Type",
    [`${currentLineItem}/plcmt`]: "Video placement sub-type",

    "/xgboost/cpmMax": "Bid price limit",
    "/xgboost/cpmMax/$numberLong": "Bid price limit",
    "/xgboost/params/targetCPI": "Target CPI",
    "/xgboost/params/targetCPA": "Target CPA",
    "/xgboost/bidPrice": '"100% probability" bid price',
    "/xgboost/userValue": "User Value",
    "/xgboost/expectedImpressions": "Expected Impressions",
    "/xgboost/roasPercent": "ROAS Percent",
    "/xgboost/modelCPMPortion": "Model Usage %",
  };
};

export const LINEITEM_HISTORY_DICT_REGEX_PATH: {
  regex: RegExp;
  display: string;
  hasDetails?: boolean;
}[] = [
  {
    regex: /.+bidModifierTerms\/sessionDuration\/\d+\/modifier?.+/,
    display: "Bid Modifier: Session Duration",
  },
  {
    regex: /.+bidModifierTerms\/sessionDuration\/\d+\/values\/\d+\/to?.+/,
    display: "Bid Modifier: Session Duration (min)",
  },
  {
    regex: /.+bidModifierTerms\/sessionDuration\/\d+\/values\/\d+\/from?.+/,
    display: "Bid Modifier: Session Duration (max)",
  },
  {
    regex: /.+bidModifierTerms\/language?.+/,
    display: "Bid Modifier: Language",
  },
  {
    regex: /.+bidModifierTerms\/publisherBundleIds?.+/,
    display: "Bid Modifier: Publisher Bundle Ids",
  },
  { regex: /.+bidModifierTerms\/adSize?.+/, display: "Bid Modifier: Ad Size" },
  {
    regex: /.+bidModifierTerms\/categories?.+/,
    display: "Bid Modifier: Content Category",
  },
  {
    regex: /.+bidModifierTerms\/deviceTypes?.+/,
    display: "Bid Modifier: Platform",
  },
  { regex: /.+dayparting?.+/, display: "Dayparting" },
  { regex: /.+geoCriteria\/whitelist?.+/, display: "Geo (location include)" },
  { regex: /.+geoCriteria\/blacklist?.+/, display: "Geo (location exclude)" },
  { regex: /.+bidModifierTerms\/os?.+/, display: "Bid Modifier: OS" },
  { regex: /.+bidModifierTerms\/geo?.+/, display: "Bid Modifier: Location" },
  {
    regex: /.+bidModifierTerms\/exchange?.+/,
    display: "Bid Modifier: Exchange",
  },
  {
    regex: /.+bidModifierTerms\/connectionType?.+/,
    display: "Bid Modifier: Connection Type",
  },
  {
    regex: /.+ext\/campaignOptimiser?.+/,
    display: "Optimiser",
    hasDetails: true,
  },
  { regex: /.+frequencyCap\/periodMs?.+/, display: "Frequency Cap Period" },
  { regex: /.+frequencyCap\/value?.+/, display: "Frequency Cap Value" },
  { regex: /.+frequencyCap\/intervalMs?.+/, display: "Frequency Cap Interval" },
  { regex: /.+frequencyCap\/total?.+/, display: "Frequency Cap Total" },
  { regex: /.+frequencyCap\/type?.+/, display: "Frequency Cap Type" },
  {
    regex: /.+skAdNetworkConfiguration?.+/,
    display: "SkAdNetworkConfiguration",
  },
  {
    regex: /.+previousSkAdNetworkConfiguration?.+/,
    display: "previous SkAdNetworkConfiguration",
  },
  { regex: /\/predictType/, display: "Predict Model Type" },
  { regex: /\/predictId/, display: "Predict Model" },
  { regex: /xgboost\/params$/, display: "Bidding Autopilot" },
  { regex: /xgboost\/params\/targetCPI/, display: "Target CPI" },
  { regex: /xgboost\/params\/targetCPA/, display: "Target CPA" },
  {
    regex: /xgboost\/userValue\/\$numberLong/,
    display: '"100% probability" bid price',
  },
  { regex: /xgboost\/userValue$/, display: "Bidding Autopilot (User Value)" },
  { regex: /xgboost\/cpmMax\/\$numberLong/, display: "Bid price limit" },
  { regex: /xgboost\/modelCPMPortion/, display: "Model Usage %" },
  {
    regex: /xgboost\/params\/threshold/,
    display: "Minimum probability to bid",
  },
  {
    //add string to match in the end here
    regex: /exchangeCpm\/([^/]+)/,
    display: "CPM per Exchange",
    hasDetails: true,
  },
];

export const CAMPAIGN_FIELD_PATH_TO_NAME_DICT = {
  "/state/archived": "Archived State",
  "/state/runState": "Run State",
  "/state/running": "Running",
  "/campaign/name": "Name",
  "/campaign/description": "Description",
  "/campaign/budget/$numberLong": "Budget",
  "/campaign/budget": "Budget",
  "/campaign/advertiserDomains": "Advertiser domains",
  "/campaign/frequencyCap": "Frequency cap",
  "/campaign/hasFrequencyCap": "Enable frequency cap",
  "/campaign/ext/installCap": "Daily install cap",
  "/campaign/ext/installCap/$numberLong": "Daily install cap",
  "/campaign/ext/optimizationEvent": "Optimiser target event",
  "/campaign/ext/optimizationTarget": "Optimiser target",
  "/campaign/ext/viewThroughAttribution": "Notify",
  "/campaign/ext/abGroups": "AB Groups",
  "/campaign/ext/abGroups/name": "AB Groups name",
  "/campaign/ext/abGroups/number": "AB Groups number",
  "/campaign/ext/numberOfAbGroups": "Number of AB Groups",
  "/campaign/ext/bundles/blacklist": "Exclude Bundles",
  "/campaign/ext/autoBlacklist": "Enable install suppression",
  "/campaign/ext/alternateBundleId": "Alternate bundle ID",
  "/campaign/frequencyCap/periodMs/$numberLong": "Frequency Cap Period",
  "/campaign/frequencyCap/periodMs": "Frequency Cap Period",
  "/campaign/frequencyCap/value/$numberLong": "Frequency Cap Value",
  "/campaign/frequencyCap/value": "Frequency Cap Value",
  "/campaign/frequencyCap/intervalMs/$numberLong": "Frequency Cap Interval",
  "/campaign/frequencyCap/intervalMs": "Frequency Cap Interval",
  "/campaign/frequencyCap/total/$numberLong": "Frequency Cap Total",
  "/campaign/frequencyCap/total": "Frequency Cap Total",
  "/campaign/cap": "Spend Cap",
  "/campaign/cap/type": "Spend Cap Type",
  "/campaign/cap/value/$numberLong": "Spend Cap Value",
  "/campaign/cap/value": "Spend Cap Value",
  "/campaign/retargeting": "Retargeting",
  "/campaign/endDate": "Finish date",
  "/campaign/skanSupported": "SKAdNetwork campaign",
  "/campaign/exploreMode": "Explore Mode",
  "/campaign/bundleOverride": "Bundle override",
  "/campaign/campaignDsa": "DSA Information",
  "/campaign/prioritiseExchangeBidding": "Preferential Exchange bidding",
  "/campaign/evergreen": "Evergreen campaign",
  "/campaign/prioritiseCampaignBidding": "Preferential Bidding",
  "/campaign/roasEvents": "Event names",
  "/campaign/bundleId": "Application id",
  "/campaign/adVerification/omsdkRequired": "Open Measurement SDK traffic only",
  "/campaign/ext/linearTrackingEnabled": "Linear tracking",
};

export const CAMPAIGN_HISTORY_DICT_REGEX_PATH = [
  { regex: /.+campaign\/ext\/abGroups\/\d?.+/, display: "One of AB Groups" },
  {
    regex: /.+campaign\/landings\/\d?.+\/impressionTrackers\/\d?.+/,
    display: "Landings Impresssion Trackers",
  },
  {
    regex: /.+campaign\/landings\/\d?.+\/clickThroughUrl?.+/,
    display: "Landings Click Through Url",
  },
  { regex: /.+campaign\/landings\/\d?.+\/name?.+/, display: "Landings Name" },
];

export const CREATIVE_FIELD_PATH_TO_NAME_DICT: Record<string, string> = {
  "/creative/name": "Creative name",
  "/creative/description": "Description",
  "/creative/contentLength": "Content length",
  "/creative/start": "Start date and time",
  "/creative/finish": "Finish date and time",
  "/creative/categories": "IAB category",
  "/creative/tag": "Folder",
  "/creative/creativeAttributes": "Creative attribute",
  "/creative/ext/region/whitelist": "Location",
  "/creative/ext/exchanges/values": "Exchange value",
  "/creative/ext/exchanges/type": "Exchange type",
  "/state/archived": "Archive creative",
  "/creative/vast": "Vast XML",
  "/creative/markup": "HTML5",
  "/creative/aspectRatios/values": "Aspect ratio",
  "/creative/ext/skOverlay": "SKOverlay",
  "/creative/ext/onlySKOverlay": "SKOverlay Only",
  "/creative/ext/autoStoreKit": "Auto-StoreKit",
  "/creative/ext/dualEndcard": "Add Exchange endcard",
  "/creative/ext/persistentCta": "Persistent CTA",
  "/creative/ext/skipToStore": "Skip to Store",
  "/creative/sizes": "Ad size",
  "/creative/apiFramework": "API frameworks",
};

export const CREATIVE_HISTORY_DICT_REGEX_PATH: {
  regex: RegExp;
  display: string;
  hasDetails?: boolean;
}[] = [
  {
    regex: /\/creative\/assets\/\d+\/image\/(width|height|url)/,
    display: "Asset image",
  },
  {
    // title is its own key on the asset, so this one is safe to name at any index
    regex: /\/creative\/assets\/\d+\/title\/text/,
    display: "App title",
  },
  {
    regex: /\/creative\/assets\/\d+\/data\/value/,
    display: "Asset data value",
  },
  {
    regex: /\/creative\/assets\/\d+\/data\/type/,
    display: "Asset data type",
  },
  {
    regex: /\/creative\/assets\/\d+\/data\/label/,
    display: "Asset data label",
  },
];
